export interface AppConfig {
  name: string;
  shortName: string;
  logoIcon: string;
}

export const environment = {
  production: false,
  debug: false,
  // Legacy Nest API proxy paths (most admin features use Supabase directly)
  domain: '',
  apiDomain: '/api',
  appConfig: {
    name: 'Supidoo',
    shortName: 'S',
    logoIcon: 'fa-solid fa-bolt',
  } satisfies AppConfig,
  supabase: {
    url: 'https://itcrhpvrkngyxhriylpm.supabase.co',
    anonKey: 'sb_publishable_FUxBBWC8-QZKkJR6i2f1_Q_GVoPIdZL',
        // url: 'https://uibfwqqvoapmyimfkwzd.supabase.co',
    // anonKey: 'sb_publishable_yCwomywl882u5P_1AD2E-g_Up7CWU2A',
  },
  googleMapsApiKey: 'AIzaSyAdBugNBdgMCWg55OOP7J1u0c_uZD7dpv0',
};
